var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Notification from "./components/common/Notification";
import NotFound from "./components/NotFound";
import MarketplaceContext from "./context/MarketplaceContext";
import { combineReducers, setLoadingFalse } from "./utils";
import authReducer from "./reducers/authReducer";
import notificationReducer from "./reducers/notificationReducer";
import marketplaceReducer from "./reducers/marketplaceReducer";
import { USER_DEFAULT_PAGE, USER_DETAILS, USER_LOGIN } from "./actions";
import AuthContext from "./context/AuthContext";
import NotificationContext from "./context/NotificationContext";
import ScrollToTop from "./components/common/ScrollToTop";
import DashboardContext from "./context/DashboardContext";
import ProtectedRoute from "./components/common/ProtectedRoute";
import DashboardExpirations from "./views/dashboard/DashboardExpirations";
import DashboardHome from "./views/dashboard/DashboardHome";
import AppLayout from "./layout/AppLayout";
import DashboardLeads from "./views/dashboard/DashboardLeads";
import DashboardSupport from "./views/dashboard/DashboardSupport";
import Home from "./views/marketing/Home";
import { Application, Marketplace as MarketplaceEnum, Paginate } from "@domainpage/shared/src/constants";
import dashboardReducer from "./reducers/dashboardReducer";
import Login from "./views/marketing/Login";
import Register from "./views/marketing/Register";
import DashboardLayout from "./layout/DashboardLayout";
import DomainPortfolio from "./views/domains/DomainPortfolio";
import DomainLayout from "./layout/DomainLayout";
import DomainNew from "./views/dashboard/DomainNew";
import QueryContext from "./context/QueryContext";
import queryReducer from "./reducers/queryReducer";
import DomainEdit from "./views/dashboard/DomainEdit";
import DomainBulk from "./views/dashboard/DomainBulk";
import DashboardAccount from "./views/dashboard/DashboardAccount";
import Features from "./views/marketing/Features";
import Pricing from "./views/marketing/Pricing";
import { ReservedSubdomains } from "./constants/subdomains";
import DomainPage from "./views/domains/DomainPage";
import DashboardBilling from "./views/dashboard/DashboardBilling";
import ResetPassword from "./views/marketing/ResetPassword";
import ForgotPassword from "./views/marketing/ForgotPassword";
import ConfirmEmail from "./views/marketing/ConfirmEmail";
import PrivacyPolicy from "./views/legal/PrivacyPolicy";
import CookiePolicy from "./views/legal/CookiePolicy";
import AcceptableUsePolicy from "./views/legal/AcceptableUsePolicy";
import TermsOfService from "./views/legal/TermsOfService";
import DomainStats from "./components/DomainStats";
import MarketplaceLayout from "./layout/MarketplaceLayout";
import Marketplace from "./views/marketplace/Marketplace";
var initialAuthState = {
    authenticated: false,
    user: {},
    defaultPage: {},
};
var initialDashboardState = {
    loading: true,
    currentPage: Paginate.PAGE,
    pageSize: Paginate.LIMIT,
};
var initialMarketplaceState = {
    currentMinPrice: MarketplaceEnum.STARTING_MIN_PRICE,
    currentMaxPrice: MarketplaceEnum.STARTING_MAX_PRICE,
    currentMinLength: MarketplaceEnum.STARTING_MIN_LENGTH,
    currentMaxLength: MarketplaceEnum.STARTING_MAX_LENGTH,
};
var initialQueryState = {
    query: "",
    results: 0,
    searching: false,
};
var initialNotificationState = {
    display: false,
    message: null,
};
var App = function () {
    var _a;
    var _b = React.useReducer(combineReducers({
        auth: authReducer,
        dashboard: dashboardReducer,
        marketplace: marketplaceReducer,
        query: queryReducer,
        notification: notificationReducer,
    }), {
        auth: initialAuthState,
        dashboard: initialDashboardState,
        marketplace: initialMarketplaceState,
        query: initialQueryState,
        notification: initialNotificationState,
    }), state = _b[0], dispatch = _b[1];
    var auth = state.auth, dashboard = state.dashboard, marketplace = state.marketplace, query = state.query, notification = state.notification;
    var fetchCurrentUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/api/current-user")];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    fetchDefaultPage().catch(function (err) { return err; });
                    if (res.ok) {
                        dispatch({ type: USER_LOGIN, payload: data });
                        dispatch({ type: USER_DETAILS, payload: data });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchDefaultPage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/api/pages/default")];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    payload = (_a.sent()).payload;
                    if (res.ok) {
                        dispatch({ type: USER_DEFAULT_PAGE, payload: payload });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setLoadingFalse(dispatch, 1000);
    }, [(_a = auth === null || auth === void 0 ? void 0 : auth.user) === null || _a === void 0 ? void 0 : _a.authenticated]);
    useEffect(function () {
        var _a;
        if (!((_a = auth === null || auth === void 0 ? void 0 : auth.user) === null || _a === void 0 ? void 0 : _a.authenticated))
            fetchCurrentUser().catch(function (err) { return err; });
    }, []);
    var authenticated = auth.authenticated;
    var renderRouteSpecificLayout = function () {
        var subdomain = window.location.host.split(".")[0];
        var isReservedSubdomain = !ReservedSubdomains.includes(subdomain);
        var isPortfolioOrLander = subdomain && isReservedSubdomain;
        var isMarketplace = subdomain && subdomain === Application.MARKETPLACE_SUBDOMAIN;
        if (isPortfolioOrLander) {
            return (_jsx("div", { children: _jsxs(Router, { children: [_jsx(ScrollToTop, {}, void 0), _jsx(Switch, { children: _jsx(Route, __assign({ path: "/" }, { children: _jsx(DomainLayout, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/", component: DomainPortfolio }, void 0), _jsx(Route, { exact: true, path: "/:domain", component: DomainPage }, void 0), _jsx(Route, { component: NotFound }, void 0)] }, void 0) }, void 0) }), void 0) }, void 0)] }, void 0) }, void 0));
        }
        else if (isMarketplace) {
            return (_jsx("div", { children: _jsxs(Router, { children: [_jsx(ScrollToTop, {}, void 0), _jsx(Switch, { children: _jsx(Route, __assign({ path: "/" }, { children: _jsx(MarketplaceLayout, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/", component: Marketplace }, void 0), _jsx(Route, { component: NotFound }, void 0)] }, void 0) }, void 0) }), void 0) }, void 0)] }, void 0) }, void 0));
        }
        else {
            return (_jsxs(Router, { children: [_jsx(ScrollToTop, {}, void 0), _jsxs(Switch, { children: [_jsx(Route, __assign({ path: "/dashboard" }, { children: _jsx(DashboardContext.Provider, __assign({ value: { state: dashboard, dispatch: dispatch } }, { children: _jsx(QueryContext.Provider, __assign({ value: { state: query, dispatch: dispatch } }, { children: _jsx(DashboardLayout, __assign({ auth: auth }, { children: _jsxs(Switch, { children: [_jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard", component: DashboardHome }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/account", component: DashboardAccount }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/billing", component: DashboardBilling }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/leads", component: DashboardLeads }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/expirations", component: DashboardExpirations }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/support", component: DashboardSupport }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/help", component: DashboardAccount }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/domains/new", component: DomainNew }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/domains/:domain/edit", component: DomainEdit }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/domains/bulk", component: DomainBulk }, void 0), _jsx(ProtectedRoute, { auth: auth, authenticated: authenticated, exact: true, path: "/dashboard/domains/:domain", component: DomainStats }, void 0)] }, void 0) }), void 0) }), void 0) }), void 0) }), void 0), _jsx(Route, { children: _jsx(AppLayout, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/", component: Home }, void 0), _jsx(Route, { exact: true, path: "/features", component: Features }, void 0), _jsx(Route, { exact: true, path: "/pricing", component: Pricing }, void 0), _jsx(Route, { exact: true, path: "/login", component: Login }, void 0), _jsx(Route, { exact: true, path: "/register", component: Register }, void 0), _jsx(Route, { exact: true, path: "/confirm-email", component: ConfirmEmail }, void 0), _jsx(Route, { exact: true, path: "/forgot-password", component: ForgotPassword }, void 0), _jsx(Route, { exact: true, path: "/reset-password", component: ResetPassword }, void 0), _jsx(Route, { exact: true, path: "/privacy-policy", component: PrivacyPolicy }, void 0), _jsx(Route, { exact: true, path: "/cookie-policy", component: CookiePolicy }, void 0), _jsx(Route, { exact: true, path: "/acceptable-use-policy", component: AcceptableUsePolicy }, void 0), _jsx(Route, { exact: true, path: "/terms-of-service", component: TermsOfService }, void 0), _jsx(Route, { component: NotFound }, void 0)] }, void 0) }, void 0) }, void 0)] }, void 0)] }, void 0));
        }
    };
    return (_jsx(AuthContext.Provider, __assign({ value: { state: auth, dispatch: dispatch } }, { children: _jsxs(NotificationContext.Provider, __assign({ value: { state: notification, dispatch: dispatch } }, { children: [_jsx(MarketplaceContext.Provider, __assign({ value: { state: marketplace, dispatch: dispatch } }, { children: _jsx("div", { children: renderRouteSpecificLayout() }, void 0) }), void 0), _jsx(Notification, { display: notification.display, title: notification.title, message: notification.message, type: notification.success }, void 0)] }), void 0) }), void 0));
};
export default App;
